import { render, staticRenderFns } from "./ImportBrands.vue?vue&type=template&id=64b8bc7d&"
import script from "./ImportBrands.vue?vue&type=script&lang=js&"
export * from "./ImportBrands.vue?vue&type=script&lang=js&"
import style0 from "./ImportBrands.vue?vue&type=style&index=0&id=64b8bc7d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports